class NavbarController {
  constructor($state, Auth) {
    this.$state = $state;
    this.Auth = Auth;
    this.name = 'navbar';
  }
  logOut() {
    const { $state, Auth } = this;
    Auth.logOut();
    $state.go('auth');
  }
}
NavbarController.$inject = ['$state', 'Auth'];
export default NavbarController;



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js